import React, { useState, useEffect } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import CloseIcon from "@mui/icons-material/Close";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { ListSubheader } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import {
    setState,
  } from "../centralAdminSlice";

const SingleSelectUOM = (props) => {
    const dispatch = useDispatch();
    const centralAdmin = useSelector((state) => state.centralAdmin);
    const {
        SelectedUOM,
      } = centralAdmin;  

  const uoMData = props?.getSKUbyCountry;
  //const selectedUOM = props?.selectedUOM;
  const uom = [...new Set(uoMData.map((item) => item.uom_sap_code))];
  const [uomName, setUomName] = useState('');
  const [searchText, setSearchText] = React.useState("");
  const [namesData, setNamesData] = React.useState([]);
  const textInput = React.useRef(null);

  const handleChange = (event) => {
    const value = event.target.value;
    setUomName(value);
    dispatch(setState("SelectedUOM", value));
  };

  useEffect(() => {
    // Clear search text value
    setNamesData(uom);
  }, [uoMData]);

  const handleInputChange = (value) => {
    debugger;
    setSearchText(value);
  };

  useEffect(() => {
    //use a debounce to delay the search input key entry
    const delayDebounceFn = setTimeout(() => {
      if (searchText) {
        //filter options state using search text provided
        setNamesData((prevVal) => {
          let val = uom.filter((name) =>
            name.toLowerCase().includes(searchText.toLowerCase())
          );

          return val;
        });
      } else {
        setSearchText();
        setNamesData(uom);
      }

      //set focus on search text input field on load. setTimeOut is added as textInput is not immediately available
      setTimeout(() => {
        if (textInput.current) textInput.current.focus();
      }, 100);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchText]);

  return (
    <div>
      <FormControl>
      <InputLabel>UOM</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          value={uomName}
          onChange={handleChange}
          size="small"
          input={<OutlinedInput label="UOM" />}
        >
          <ListSubheader>
            <TextField
              size="small"
              inputRef={textInput}
              //selectedUOM
              placeholder=""
              value={searchText}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  /*close icon to clear the search text*/
                  <InputAdornment position="end">
                    <IconButton onClick={() => setSearchText("")}>
                      <CloseIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onChange={(e) => handleInputChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  // Prevents autoselecting item while typing (default Select behaviour)
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>

          {namesData?.map((name, index) => (
            <MenuItem key={index + name} value={name}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default SingleSelectUOM;
